export default __webpack_public_path__ + "static/media/kanishq.fa92d076.jpg";